<!--
 * @Author: pingping.mao
 * @Date: 2022-12-28 14:09:13
 * @LastEditTime: 2022-12-29 15:43:32
 * @LastEditors: pingping.mao
 * @Description:
 * @FilePath: \common-web\src\views\standard\sql-manage\list.vue
-->
<template>
  <div class="padding24">
    <el-row :gutter="24">
      <el-col :span="8">
        <el-select style="width: 100%" clearable v-model="selectedDatabase" placeholder="请选择数据库" @change="getDatabaseFormById">
          <el-option
            v-for="item in databaseList"
            :key="item.id"
            :label="item.datasourceName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-select  style="width: 100%" clearable v-model="selectedDatabaseForm" placeholder="请选择表结构" @change="getFormFieldById">
          <el-option
            v-for="item in formList"
            :key="item.tableName"
            :label="`${item.tableDesc}(${item.tableName})`"
            :value="item.tableName"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-button type="primary" :loading="loading" @click="executeSql">执行sql</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="24">
        <SQLCodeMirror
          ref="codemirrorEditor"
          :run-loading="runLoading"
          :options="sqlOptions"
          @input="onEditorInput"
        ></SQLCodeMirror>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="24">
        <div class="tables-result" :style="{height: `430px`}">
          <el-tabs type="border-card" style="height: 99%">
            <el-tab-pane label="信息">
              <ul class="margin-top" style="height: 350px; overflow: auto">
                <li v-for="item in formFieldList" :key="item.field">{{item.field}}：{{item.fieldDesc}}</li>
                <li v-if="formFieldList.length === 0">暂无数据</li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="结果">
              <SQLCodeMirror
                ref="resultEditor"
                :options="jsOptions"
              ></SQLCodeMirror>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SQLCodeMirror from "./CodeMirror";
import sqlApi from "@/api/sql-manage";
export default {
  name: "Sql",
  components: { SQLCodeMirror },
  data() {
    return {
      runLoading: false,
      selectedDatabase: null,
      selectedDatabaseForm: null,
      databaseList: [],
      formList: [],
      formFieldList: [],
      code: "",
      loading: false,
      sqlOptions: {
        mode: "text/x-sparksql", // spark sql模式
        lineNumbers: true, // 显示行号
        styleActiveLine: true, // 激活当前行
        theme: "default", // 主题
        lineWrapping: true, // 自动换行
        matchBrackets: true, // 括号匹配
        autoCloseBrackets: true,
        line: true,
        extraKeys: { // 触发提示按键
          "Ctrl": "autocomplete"
        },
        hintOptions: { // 自定义提示选项
          completeSingle: false, // 当匹配只有一项的时候是否自动补全
          tables: {} // 代码提示
        },
      },
      jsOptions: {
        mode: "javascript",
        lineNumbers: true, // 显示行号
        styleActiveLine: true, // 激活当前行
        theme: "default", // 主题
        lineWrapping: true, // 自动换行
        matchBrackets: true, // 括号匹配
        autoCloseBrackets: true,
        line: true,
        foldGutter: true,
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        readOnly: true
      }
    };
  },
  created() {
    this.getDatabaseList();
  },
  methods: {
    getDatabaseList() {
      sqlApi.getDatabaseList().then(res => {
        if (res.success && res.data && res.data.length) {
          this.databaseList = res.data;
        }
      });
    },
    getDatabaseFormById(id) {
      this.selectedDatabaseForm = null;
      this.formList = [];
      this.formFieldList = [];
      if (id) {
        sqlApi.getDatabaseFormById({id}).then(res => {
          if (res.success && res.data && res.data.length) {
            this.formList = res.data;
          }
        });
      }
    },
    getFormFieldById() {
      this.formFieldList = [];
      if (this.selectedDatabase && this.selectedDatabaseForm) {
        sqlApi.getFormFieldById({id: this.selectedDatabase, tableName: this.selectedDatabaseForm }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.formFieldList = res.data;
          }
        });
      }
    },
    executeSql() {
      if (this.code === "") {
        this.$message.warning("请输入sql");
        return;
      }
      if (!this.selectedDatabase) {
        this.$message.warning("请选择数据库");
        return;
      }
      this.loading = true;
      sqlApi.executeSql({id: this.selectedDatabase, sql: this.code}).then(res => {
        this.loading = false;
        this.$refs.resultEditor.setValue(JSON.stringify(res, null, 4));
      }, err => {
        this.loading = false;
      });
    },
    onEditorInput(code) {
      // 编辑器输入事件
      this.code = code;
    }
  }
};
</script>

<style scoped lang="scss"></style>
